import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import * as animationData from './contact.json';
import Lottie from 'react-lottie';

const HeroSection = () => {
  const defaultOptions = {
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <m.section className='py-[50px] lg:py-[45px] md:py-[35px] sm:py-[25px]'>
      <Container className='h-[100px] sm:h-[250px] flex justify-center sm:justify-end'>
        <Row xs={1} md={1} className='items-end justify-end sm:flex-col'>
          <Col className='items-end justify-end sm:flex-col'>
            <Lottie options={defaultOptions} height={210} speed={0.7} />
          </Col>
        </Row>
      </Container>
    </m.section>
  );
};

export default HeroSection;
